import React, { useState, useRef} from "react";
import ProcessBar from "../MainComponent/processBar";
import ElectricalInfo from "./electricalInfo";
import "./electrical.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export default function ElectricalDetail() {
  const [emptyValues, setEmptyValues] = useState(false)
  const projectId = useSelector((state) => state.roof.id);
  
  const oneLineRef = useRef(null)

  return (
    <>
      <div className="electricalDetail">
        <div className="electricalHead">
          <div className="electricalHeader">
            <Link to="/Dashboard">
              <h6 style={{ color: "#FF7C1B" }}>My Project</h6>
            </Link>
            <h6>/</h6>
            {!projectId ? <h6>Create Project</h6> : <h6>Edit Project</h6>}
          </div>
          <ProcessBar setEmptyValues={setEmptyValues} oneLineRef={oneLineRef}></ProcessBar>
        </div>
        <ElectricalInfo
          emptyValues={emptyValues}
          oneLineRef={oneLineRef}
        ></ElectricalInfo>
      </div>
    </>
  );
}
